import { ITripDetails } from "../Interfaces/ITripDetails";

export const defaultTripDetails: ITripDetails = {
  appointmentTime: "",
  bookingId: "",
  customerId: 0,
  dropLatitude: 0,
  dropLongitude: 0,
  dropNotes: "",
  dropOffAddress1: "",
  dropOffAddress2: "",
  dropOffCity: "",
  dropOffState: "",
  dropOffZipCode: 0,
  dropOffCounty: "",
  favoriteId: 0,
  favoriteName: "",
  firstName: "",
  isWillCall: false,
  lastName: "",
  levelOfService: "",
  levelOfServiceCost: 0,
  levelOfServiceId: 0,
  modeId: 0,
  paymentInstrumentId: 0,
  personId: 0,
  pickLatitude: 0,
  pickLongitude: 0,
  pickUpAddress1: "",
  pickUpAddress2: "",
  pickUpCity: "",
  pickUpState: "",
  pickUpZipCode: 0,
  pickUpCounty: "",
  pickupNotes: "",
  providerCost: 0,
  providerDistance: 0,
  requestAssignmentId: 0,
  requestPickTime: "",
  serviceUser: "",
  sourceSystemId: 0,
  statusDetail: "",
  transportationCost: 0,
  tripAttributes: "",
  tripCost: 0,
  tripDate: "",
  tripId: "",
  tripReason: "",
  tripReasonId: 0,
  tripStatusId: 0,
  typeOfService: "",
  vehicleTypeCost: 0,
  wandaSubscriptionPlan: "",
  wandaPlanPercentage: 0,
  wandaPlusDiscountCost: 0,
  id: 0,
  promoCodeDetail: {
    promoCode: "",
    discountType: "",
    discountValue: "",
    discountedAmount: 0,
  },
  redemptionId: "",
};
